import { ChatBubbleLeftRightIcon, MinusCircleIcon } from "@heroicons/react/24/solid";
import { Button } from "@moe/oss/ui/button";
import { Character } from "@moe/priv/model/character";
import { chatConfig } from "@moe/priv/model/chat";
import { ManageCharactersView } from "@web/components/ManageCharacterView";
import { useCreateChat } from "@web/hooks/use-create-chat";
import { useState } from "react";
import { toast } from "sonner";

export function CreateGroupChatModal() {
  const [selectedCharacters, setSelectedCharacters] = useState<Character[]>([]);
  const createChat = useCreateChat();

  const handleCharacterAdd = (char: Character) => {
    if (selectedCharacters.length >= chatConfig.maxCharacters) {
      toast.warning(`You can only have ${chatConfig.maxCharacters} characters in a chat.`);
      return;
    }
    setSelectedCharacters((prev) => [...prev, char]);
  };

  const handleRemoveCharacter = (char: Character) => {
    setSelectedCharacters((prev) => prev.filter((c) => c.id !== char.id));
  };

  const getCharacterActions = (char: Character) => {
    return [
      {
        label: "Kick",
        icon: MinusCircleIcon,
        onSelect: () => handleRemoveCharacter(char),
        className: "text-danger"
      }
    ];
  };

  const handleCreateChat = async () => {
    if (selectedCharacters.length === 0) {
      toast.warning("Please select at least one character");
      return;
    }

    await createChat(selectedCharacters);
  };

  const action = (
    <Button onClick={handleCreateChat} disabled={selectedCharacters.length === 0} className="mx-auto w-fit">
      <ChatBubbleLeftRightIcon />
      Create Chat
    </Button>
  );

  return (
    <ManageCharactersView
      charactersInChat={selectedCharacters}
      onCharacterAdd={handleCharacterAdd}
      maxCharacters={chatConfig.maxCharacters}
      title="Create Group Chat"
      description="Select characters to start a new chat (ﾉ◕ヮ◕)ﾉ*:･ﾟ✧"
      getCharacterActions={getCharacterActions}
      action={action}
    />
  );
}
